import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ className = "h-9", light = false }) => (
  <Link to="/" data-testid="nav-logo" className="inline-flex items-center">
    <img
      src="/logo.png"
      alt="SHAROA"
      className={`${className} w-auto object-contain ${light ? "brightness-0 invert" : ""}`}
    />
  </Link>
);
